/** @jsx jsx */
import { jsx } from '@emotion/react';

import type { Document } from '@contentful/rich-text-types';

import { articleBodyStyles } from 'bundles/shared-articles/styles/articleBody';
import RichText from 'bundles/unified-seo-content-common/components/rich-text/RichText';
import type { SeoContentLinksFragment } from 'bundles/unified-seo-content-common/types';

type Props = {
  body: Document;
  links?: SeoContentLinksFragment;
};

const RichTextContentRenderer = ({ body, links }: Props) => {
  return (
    <div css={articleBodyStyles}>
      <RichText className="rc-RichText" content={body} links={links} />
    </div>
  );
};

export default RichTextContentRenderer;
